import React, {Fragment} from 'react';
import styled from 'styled-components';
import {Grid, GridColumn} from '@atlaskit/page';
import {gridSize} from '@atlaskit/theme';
import Button from '@atlaskit/button';
import ArrowLeftIcon from '@atlaskit/icon/glyph/arrow-left';
import {useHistory} from 'react-router-dom';

const Padding = styled.div`
  margin: ${gridSize() * 4}px ${gridSize() * 8}px;
  margin-top: 20px;
  padding-bottom: ${gridSize() * 3}px;
`;
const BackButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  left: 28px;
  position: absolute;
  top: 20px;
`;

export const ContentWrapper = ({children}) => (
  <Grid>
    <GridColumn>
      <Padding>{children}</Padding>
    </GridColumn>
  </Grid>
);

export default ({children}) => {
  const history = useHistory();
  return (
  <Fragment>
    <ContentWrapper>
      {children}
    </ContentWrapper>
    <BackButtonWrapper>
      <Button
        onClick={() => {
          history.goBack();
        }}
        //href='javascript:history.back()'
        appearance='subtle'
        iconBefore={<ArrowLeftIcon />}
      />
    </BackButtonWrapper>
  </Fragment>
  )
}
